import Captcha from '../class/Captcha';
import Form from '../class/Form';
import { post } from '../utils/functions';

export default class EventRegistration {
	constructor(className) {
		const sections = document.querySelectorAll(`.${className}`);
		sections.forEach((section) => new Section(section));
	}
}

class Section {
	constructor(section) {
		this.section = section;

		const formEl = section.querySelector('form');
		if (formEl) {
			this.form = new Form(formEl, {
				onSubmit: this.onSubmit.bind(this),
			});
		}
	}

	onSubmit(ev) {
		ev.preventDefault();
		if (this.isRegistering) return;

		this.form.submitButton.load();
		this.isRegistering = true;
		Captcha.submit()
			.then(() => {
				post(
					{
						action: 'event_registration',
						form: this.form.el,
					},
					this.submitResponse.bind(this),
					true
				);
			})
			.catch(() => {
				this.isRegistering = false;
				this.form.submitButton.reset();
			});
	}

	submitResponse(res) {
		const response = JSON.parse(res);
		this.isRegistering = false;
		if (response.success) {
			this.form.replace(response.data);
		} else {
			this.form.submitButton.reset();
			this.form.displayErrors([response.data]);
		}
	}
}
